import { Theme as BaseTheme } from '@melements/front-components';

import { buttonRuleSets } from './ruleSets/button';
import { Theme as ThemeInterface } from './Theme.types';
import { variables } from './variables/variables';

export const Theme: ThemeInterface = {
  ...BaseTheme,
  ruleSets: {
    button: buttonRuleSets,
  },
  variables,
};
